<mat-tab-group
	class="top"
	fxFill
	animationDuration="200ms"
	mat-stretch-tabs="false"
	mat-align-tabs="start"
>
	@for (tabName of tabNames; track tabName) {
		<mat-tab [label]="tabName || 'Properties'">
			@if (propertiesForm.value(); as propertiesForm) {
				<div [formGroup]="propertiesForm" class="properties-grid">
					@for (wizard of wizardDialogs; track wizard) {
						<div class="property">
							<a href="#" (click)="openWizardDialog($event, wizard)">
								{{ wizard.label }}
							</a>
						</div>
					}
					@for (block of tabPropertyBlocks[tabName]; track block) {
						<ng-container
							*ngTemplateOutlet="
								asPropertyBlock(block).type == 'fieldset'
									? fieldsetTemplate
									: propertyTemplate;
								context: { $implicit: block }
							"
						></ng-container>
					}
					<ng-template #fieldsetTemplate let-block>
						@if (asFieldsetPropertyBlock(block); as block) {
							<fieldset class="properties-fieldset">
								<legend>{{ block.legend }}</legend>
								@for (child of block.propertyBlocks; track child) {
									<ng-container
										*ngTemplateOutlet="
											propertyTemplate;
											context: { $implicit: child }
										"
									></ng-container>
								}
							</fieldset>
						}
					</ng-template>
					<ng-template #propertyTemplate let-block>
						@if (asPropertyPropertyBlock(block)?.property; as property) {
							<div
								class="property"
								[style.gridColumn]="property.spanColumns || 'auto'"
							>
								<div
									class="property__name"
									[style.color]="block.property.obsolete ? 'red' : ''"
								>
									<label [attr.for]="property.key">{{
										getLabel(property)
									}}</label>
									@if (
										property.tooltip &&
											property?.tooltip(items(), properties, bo());
										as tooltip
									) {
										<lowgile-help vPosition="above">
											@if (tooltip.acceptHtml) {
												<div [innerHtml]="tooltip.text | safeHtml"></div>
											} @else {
												{{ tooltip.text }}
											}
										</lowgile-help>
									}
									<span class="mandatoryAsterisk">
										@switch (
											property.isMandatory &&
											property.isMandatory(items(), properties, bo())
										) {
											@case (true) {
												<span>*</span>
											}
											@case ('(*)') {
												<span><sup>(</sup>*<sup>)</sup></span>
											}
										}
									</span>
									@if (
										asTsCodeProperty(property)?.alternativeContentAreaName &&
										isBlock(items()[0]) &&
										!items()[0].getContentArea(
											asTsCodeProperty(property)?.alternativeContentAreaName
										)
									) {
										<div>
											<a
												class="add-content-area"
												href="#"
												(click)="
													$event.preventDefault();
													addContentAreaForProperty(asTsCodeProperty(property))
												"
												>(move to Content Area)</a
											>
										</div>
									}
								</div>
								<div class="property-control flexRow gap-m fill">
									@if (areValuesMatching.get(property.key)) {
										<div class="property__input">
											<div>
												@switch (property.inputType) {
													@case ('input') {
														<div>
															@switch (asInputProperty(property).elementType) {
																@case ('input') {
																	<input
																		[formControl]="
																			$any(
																				propertiesForm.controls[property.key]
																			)
																		"
																		[id]="property.key"
																		[type]="
																			asInputProperty(property).contentType
																		"
																		(keydown.delete)="stopPropagation($event)"
																		(ngModelChange)="
																			onPropertyChanged(property, false)
																		"
																	/>
																}
																@case ('textarea') {
																	<textarea
																		[formControl]="
																			$any(
																				propertiesForm.controls[property.key]
																			)
																		"
																		[id]="property.key"
																		(keydown.delete)="stopPropagation($event)"
																		(ngModelChange)="
																			onPropertyChanged(property, false)
																		"
																	></textarea>
																}
															}
														</div>
													}
													@case ('code') {
														<div
															class="code-editor"
															[class.singleLine]="
																asTsCodeProperty(property).editorSize ==
																'singleline'
															"
														>
															@if (
																isBlock(items()[0]) &&
																items()[0].getContentArea(
																	asTsCodeProperty(property)
																		.alternativeContentAreaName
																)
															) {
																<div>
																	(is contained in Content Area "{{
																		asTsCodeProperty(property)
																			.alternativeContentAreaName
																	}}")
																	<a
																		href="#"
																		(click)="
																			$event.preventDefault();
																			removeContentAreaForProperty(
																				asTsCodeProperty(property)
																			)
																		"
																		>[remove Content Area]</a
																	>
																</div>
															} @else {
																@if (
																	textOrCodeProperties.get(property.key);
																	as textOrCode
																) {
																	<div
																		style="
																			display: flex;
																			align-items: flex-start;
																		"
																	>
																		@if (textOrCode.canSwitchType()) {
																			<span
																				(click)="
																					cycleTextOrCodeType(textOrCode)
																				"
																				style="
																					padding: 0.25em;
																					cursor: pointer;
																					border: 1px solid gainsboro;
																				"
																				>{{ textOrCode.type }}</span
																			>
																		}
																		<div style="flex: 1 0 auto">
																			@switch (textOrCode.type) {
																				@case ('T') {
																					<input
																						[formControl]="
																							$any(
																								propertiesForm.controls[
																									property.key
																								]
																							)
																						"
																						[id]="property.key"
																						[type]="
																							asInputProperty(property)
																								.contentType
																						"
																						(keydown.delete)="
																							stopPropagation($event)
																						"
																						(ngModelChange)="
																							onPropertyChanged(property, false)
																						"
																					/>
																				}
																				@case ('E') {
																					<code-editor-new
																						[formControl]="
																							$any(
																								propertiesForm.controls[
																									property.key
																								]
																							)
																						"
																						[id]="property.key"
																						size="singleline"
																						[typeDeclarations]="
																							typeDeclarations()
																						"
																						[context]="
																							getCodeContext$(property) | async
																						"
																						(ngModelChange)="
																							onPropertyChanged(property, false)
																						"
																					></code-editor-new>
																					Returns
																					{{ getTsReturnType(property) }}
																				}
																				@case ('C') {
																					<code-editor-new
																						[formControl]="
																							$any(
																								propertiesForm.controls[
																									property.key
																								]
																							)
																						"
																						[id]="property.key"
																						[size]="
																							asTsCodeProperty(property)
																								.editorSize
																						"
																						[typeDeclarations]="
																							typeDeclarations()
																						"
																						[context]="
																							getCodeContext$(property) | async
																						"
																						(ngModelChange)="
																							onPropertyChanged(property, false)
																						"
																					></code-editor-new>
																					Returns
																					{{ getTsReturnType(property) }}
																				}
																			}
																		</div>
																	</div>
																} @else {
																	<!-- <div style="background-color: orange">
																		TODO: Migrate to TextOrCode
																	</div> -->
																	<code-editor-new
																		[formControl]="
																			$any(
																				propertiesForm.controls[property.key]
																			)
																		"
																		[id]="property.key"
																		[size]="
																			asTsCodeProperty(property).editorSize
																		"
																		[typeDeclarations]="typeDeclarations()"
																		[context]="
																			getCodeContext$(property) | async
																		"
																		(ngModelChange)="
																			onPropertyChanged(property, false)
																		"
																	></code-editor-new>
																	Returns {{ getTsReturnType(property) }}
																}
															}
														</div>
													}
													@case ('dropdown') {
														<select
															[formControl]="
																$any(propertiesForm.controls[property.key])
															"
															[id]="property.key"
															(ngModelChange)="
																onPropertyChanged(property, true)
															"
														>
															@if (
																asDropdownProperty(property).noneOptionName
															) {
																<option
																	[value]="
																		asDropdownProperty(property).noneOptionValue
																	"
																>
																	<em>(none)</em>
																</option>
															}
															@for (
																option of asDropdownPropertyOptions(property)
																	| async;
																track option[0]
															) {
																<option [value]="option[0]">
																	{{ option[1] }}
																</option>
															}
														</select>
													}
													@case ('checkbox') {
														<input
															type="checkbox"
															[formControl]="
																$any(propertiesForm.controls[property.key])
															"
															(ngModelChange)="
																onPropertyChanged(property, true)
															"
														/>
													}
													@case ('boRef') {
														<select
															[formControl]="
																$any(propertiesForm.controls[property.key])
															"
															[id]="property.key"
															(ngModelChange)="
																onPropertyChanged(property, true)
															"
															[compareWith]="matchBoRefs"
														>
															@if (asBoRefProperty(property).noneOptionName) {
																<option [value]="null">
																	<em>{{
																		asBoRefProperty(property).noneOptionName
																	}}</em>
																</option>
															}
															@for (
																option of boRefs$[property.key] | async;
																track option
															) {
																<option [ngValue]="option">
																	{{ option.getQualifiedName() }}
																</option>
															}
														</select>
													}
													@case ('boRefDetail') {
														<select
															[formControl]="
																$any(propertiesForm.controls[property.key])
															"
															[id]="property.key"
															(ngModelChange)="
																onPropertyChanged(property, true)
															"
														>
															@if (
																asBoRefDetailProperty(property).noneOptionName
															) {
																<option [value]="undefined">
																	<em>{{
																		asBoRefDetailProperty(property)
																			.noneOptionName
																	}}</em>
																</option>
															}
															@for (
																option of boRefDetails$[property.key] | async;
																track option
															) {
																<option [ngValue]="option[0]">
																	{{ option[1] }}
																</option>
															}
														</select>
													}
													@case ('typeDropdown') {
														<lowgile-type-reference
															[formControl]="
																$any(propertiesForm.controls[property.key])
															"
															(ngModelChange)="
																onPropertyChanged(property, true)
															"
														></lowgile-type-reference>
													}
												}
											</div>
										</div>
									} @else {
										<div class="flexRow" style="gap: 1em">
											<em>(Values are not matching)</em>
											<a
												href="#"
												(click)="
													setMultiSelectionValue(property, 'first');
													$event.preventDefault()
												"
												>Use first selection's value</a
											>
											<lowgile-help>{{
												getMultiSelectionValue(property, 'first')
											}}</lowgile-help>
											<a
												href="#"
												(click)="
													setMultiSelectionValue(property, 'last');
													$event.preventDefault()
												"
												>Use last selection's value</a
											>
											<lowgile-help>{{
												getMultiSelectionValue(property, 'last')
											}}</lowgile-help>
										</div>
									}
									@if (property.quickActions?.length) {
										<div>
											<div class="flexRow gap-xs">
												@for (
													action of property.quickActions;
													track action.name
												) {
													@if (
														!action.isVisible ||
														action.isVisible(items(), properties, bo())
													) {
														<button
															(click)="
																action.action(items(), properties, bo());
																onPropertyChanged(property, true)
															"
															[title]="
																action.shortcutKey
																	? 'Shortcut key: ' + action.shortcutKey
																	: ''
															"
														>
															{{ action.name }}
														</button>
													}
												}
											</div>
										</div>
									}
								</div>
							</div>
						} @else {
							<div class="property"></div>
						}
					</ng-template>
				</div>
			}
		</mat-tab>
	}

	@for (tab of additionalTabs; track tab) {
		<mat-tab [label]="tab.label">
			<ng-container [ngTemplateOutlet]="tab.templateRef"></ng-container>
		</mat-tab>
	}
</mat-tab-group>
